import React, {useCallback} from 'react';
import Button, {ButtonProps} from '@material-ui/core/Button';
import MenuItemAnchor, {MenuItemAnchorProps} from './MenuItemAnchor';
import gettext from '../../utils/django/gettext';
import {AuthModalState} from '../AuthModal';

const sharedProps = {
    children: gettext('Sign Up'),
    href: `/register/${Gaia.nextFromRegister}`,
};

function isHidden(user: User | undefined) {
    return !user || user.isAuthenticated;
}

type ToolbarProps = ButtonProps & {
    user: User | undefined;
    setAuthModal: SetState<AuthModalState>;
};

function Toolbar({style, user, setAuthModal, ...props}: ToolbarProps) {
    const openAuthModal = useCallback(() => {
        if (window.location.pathname === '/login/') {
            window.location.href = `/register/${window.location.search}`;
        } else {
            setAuthModal({
                form: 'register',
                analyticsContext: 'header register',
            });
        }
    }, [setAuthModal]);

    if (
        window.location.pathname === '/register/' ||
        window.location.pathname === '/' ||
        isHidden(user)
    )
        return null;

    return (
        <>
            <Button
                {...props}
                onClick={openAuthModal}
                style={{...style, color: '#fff'}}
                color='primary'
                variant='contained'
            >
                {gettext('Sign Up')}
            </Button>
        </>
    );
}

const HamburgerMenu = React.forwardRef(
    // eslint-disable-next-line prefer-arrow-callback
    function HamburgerMenuInner(
        props: MenuItemAnchorProps & {user: User | undefined},
        ref: React.Ref<any>
    ) {
        if (isHidden(props.user)) return null;
        return <MenuItemAnchor ref={ref as any} {...props} {...sharedProps} />;
    }
);

export default {Toolbar, HamburgerMenu};
